// extracted by mini-css-extract-plugin
export default {"desktop_width":"1024px","tablet_landscape_max_width":"1366px","tablet_width":"768px","link":"styles_link__FRAwR","disclaimer":"styles_disclaimer__wHWtS"};